import { render, staticRenderFns } from "./activitytranslations.vue?vue&type=template&id=9e7c8fb0&"
import script from "./activitytranslations.vue?vue&type=script&lang=js&"
export * from "./activitytranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports